import React from 'react'
import styled from 'styled-components'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'
import CircularProgress from '@material-ui/core/CircularProgress'

const ReservationListFeedback = ({ loading, error, initial, onRetry }) => {
  const intl = useIntl()
  if (!loading && !error) return null

  return (
    <Feedback
      initial={initial}
      role={loading ? 'status' : 'alert'}
      aria-label={
        loading ? intl.formatMessage({ id: 'common.loading' }) : undefined
      }
    >
      {loading ? (
        <CircularProgress size={initial ? 28 : 18} />
      ) : (
        <>
          <FormattedMessage id='common.errorMessage' />
          <RetryButton type='button' onClick={onRetry}>
            <FormattedMessage id='offers.mapRoundTripRetry' />
          </RetryButton>
        </>
      )}
    </Feedback>
  )
}

const Feedback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem;
  min-height: ${({ initial }) => (initial ? '12vh' : '0')};
  font-size: 0.8rem;
`

const RetryButton = styled.button`
  padding: 0.4rem 0.7rem;
  border: 1px solid currentColor;
  background: transparent;
  color: ${({ theme }) => theme.colors.easternBlue.hex()};
  cursor: pointer;
`

export default ReservationListFeedback
